import { render } from "./BatchNumberChangeModal.vue?vue&type=template&id=182edbb9"
import script from "./BatchNumberChangeModal.vue?vue&type=script&lang=js"
export * from "./BatchNumberChangeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__